import React, { createContext, useContext } from 'react';
import useGcpUrlHook from '../../../hooks/Dashboard/gcp/useUrl';

export const GcpUrlContext = createContext();

export const GcpUrlProvider = ({ children }) => {
  const data = useGcpUrlHook(); // Import everything from the hook

  return (
    <GcpUrlContext.Provider value={data}>
      {children}
    </GcpUrlContext.Provider>
  );
};

export const useGcpUrl = () => useContext(GcpUrlContext);